import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { register } from "../api/authApi";
import type { RegisterRequest } from "../types/auth";
import { useLanguage } from "../i18n/LanguageContext";

export function RegisterPage() {
  const navigate = useNavigate();
  const { t } = useLanguage();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [email, setEmail] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    try {
      setLoading(true);
      setError(null);

      const request: RegisterRequest = {
        username,
        password,
        email,
        dateOfBirth,
        repeatPassword,
      };
      await register(request);

      // Nach erfolgreicher Registrierung zum Login
      navigate("/login");
    } catch (err) {
      setError(err instanceof Error ? err.message : "Registration failed");
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="auth-page">
      <section className="auth-card">
        <h1>Valesco</h1>

        <form onSubmit={handleSubmit}>
          {error && (
            <div className="form-error" style={{ marginBottom: 12 }}>
              {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="username">{t.auth.username}</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">{t.auth.email}</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="dateOfBirth">{t.auth.dateOfBirth}</label>
            <input
              id="dateOfBirth"
              type="date"
              value={dateOfBirth}
              onChange={(e) => setDateOfBirth(e.target.value)}
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">{t.auth.password}</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="repeatPassword">{t.auth.repeatPassword}</label>
            <input
              id="repeatPassword"
              type="password"
              value={repeatPassword}
              onChange={(e) => setRepeatPassword(e.target.value)}
              required
              disabled={loading}
            />
          </div>

          <button className="primary-button" type="submit" disabled={loading}>
            {loading ? t.auth.registering : t.auth.register}
          </button>
        </form>

        <p className="form-footer">
          {t.auth.haveAccount}{" "}
          <button
            type="button"
            className="link-button"
            onClick={() => navigate("/login")}
          >
            {t.auth.loginLink}
          </button>
        </p>
      </section>
    </main>
  );
}
